import weChatJsApiPay from '@/utils/weChatJsApiPay';
import { judgeUserAgent } from '@/utils/judgeUserAgent'
import { moviePayApi, doPay } from '@/api/pay';
import { getuser } from '@/api/user'
import router from '@/router'

// 支付非微信浏览器
const wxPayByH5 = async ({ payId, orderId, couponId }) => {
	const result = await doPay({
    pay_id: payId,
    card_id: couponId,
	}).catch((err) => console.log(err));
	const { status, payment } = result.data.data;
	if (!status) {
		return result.data.data;
	}

	if (payment.pay_data && payment.pay_data.trade_type === 'MWEB') {
		document.location.href = payment.pay_data.mweb_url;
		return
	}

	return result.data.data;
};
// 微信浏览器
const wxPayByWx = async ({ payId, orderId, couponId }) => {
	let openId = '';
	const openIdResult = await getuser();
	const { status: openIdStatus, isBindWechat } = openIdResult.data.data;
	console.log(openIdStatus, isBindWechat);
	
	if (openIdStatus && isBindWechat) {
		openId = openIdResult.data.data.openId;
	} else {
		console.log(router.history.current.fullPath);
		router.push({
			path: '/UserInfoHandle',
			query: {
				redirect: router.history.current.fullPath
			}
		});
		// return {
		// 	status: false,
		// 	message: '未绑定微信'
		// };
	}
	
	// 调起支付
	const payResult = await doPay({
		pay_id: payId,
		card_id: couponId,
		openid: openId
	});

	const { status: payStatus, payment } = payResult.data.data;
	console.log(payStatus);
	
	 // 如果调启失败
	if (!payStatus) {
		return payResult.data.data;
	}

	const wechatPayResult = await weChatJsApiPay({
			...payment.pay_data
		}).catch((err) => {
			console.log(err);
		});
	
		return wechatPayResult;
	
	// if (payStatus) {
	// 	// 唤起微信支付
	// 	const wechatPayResult = await weChatJsApiPay({
	// 		...payment.pay_data
	// 	}).catch((err) => {
	// 		console.log(err);
	// 	});
	// 	return wechatPayResult;
	// } else {
	// 	return {
	// 		status: payResult.data.data
	// 	};
	// }
};
// 电影支付
const moviePay = async ({ payType, orderId }) => {
	const result = moviePayApi({
		order_id: orderId,
		payment_type: payType
  });
  return result.data.data
};

export const payOrderHandle = async ({ payType, payId = '', orderId, couponId }) => {
	let result = {}
  if (payType === 3) {
    if (judgeUserAgent('weChat')) {
      result = await wxPayByWx({ payType, payId, orderId, couponId });
    } else {
      result = await wxPayByH5({ payType, payId, orderId, couponId });
    }
  } else {
    result = await moviePay({ payType, payId, orderId, couponId });
	}
	
  return result
};
